<template>
  <v-container>
    <tool-form schema="new" title="NUEVA HERRAMIENTA" />
  </v-container>
</template>

<script>
import ToolForm from "../../components/Forms/ToolForm.vue";
export default {
  components: { ToolForm },
};
</script>

<style></style>
